module.exports = __webpack_public_path__ + "static/img/celoscope-23.76d68c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-23.jpg
// module id = TTC3
// module chunks = 52